require.register("app/ui/form/RestaurantSelect", function(exports, require, module){
  $0
  
});

